export default __webpack_public_path__ + "static/media/B214.591cc8eb.png";